/**
 * The key associated with the resource data's dropdown fields.
 */
export const ResourceDataKeys = {
    radioServiceCode: 'RADIO_SERVICE_CODE',
    licenseType: 'LICENSE_TYPE',
    useOfServiceType: 'USE_OF_SERVICE_TYPE',
    applicantTypeCode: 'APPLICANT_TYPE_CODE',
    stateCode: 'STATE_CODE',
    actionCode: 'ACTION_CODE',
    locationType: 'LOCATION_TYPE',
    areaOfOperationCodes: 'AREA_OF_OPERATION',
    structureTypeCodes: 'STRUCTURE_TYPE',
    siteStatusCodes: 'SITE_STATUS',
    polarizationCodes: 'POLARIZATION_CODE',
    frequencyType: 'FREQUENCY_TYPE',
    stationClass: 'STATION_CLASS_CODE',
    publicSafetyCoordinators: 'PUBLIC_SAFETY_COORDINATOR',
    emissionDesignator: 'EMISSION_DESIGNATOR',
    applicationType: 'SALMON_APPLICATION_TYPE',
    frequencyAllocationCode: 'SALMON_FREQUENCY_TYPE',
    elibilityRule: 'ELIGIBILITY_RULE',
    scheduleKPurposes: 'SCH_K_PURPOSE',
    attachmentCodes: 'ATTACHMENT_CODE',
    coresRegistrationType: 'CORES_REG_TYPE',
    salutation: 'SALUTATION',
    tinExceptionReason: 'TIN_EXCEPTION_REASON',
    securityQuestion: 'SECURITY_QUESTION',
    businessEntityType: 'BUSINESS_ENTITY_TYPE',
    entityType: 'ENTITY_TYPE',
    frnSearchType: 'FRN_SEARCH_TYPE',
};
